module.exports = __webpack_public_path__ + "doctor_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_4.jpg
// module id = 891
// module chunks = 0